/**
 * The connection's file account facts (Task 7.4b: kind, billing model, large file shares) as the renderer sees them in
 * `storageAccountInfoStore` — the same facts main bounds a quota with — and the quota-range line the create and quota
 * dialogs show under their field.
 */
import { shareQuotaRange } from '../../../../../core/engines/azureStorageShareQuota';
import type { FileAccountFacts } from '../../../../../types/azureStorage';
import { useStorageAccountInfoStore } from '../../../../database-objects/store/storageAccountInfoStore';

const UNKNOWN_FACTS: FileAccountFacts = { billing: 'unknown', largeFileShares: 'unknown', source: 'none' };

export function useFileAccountFacts(connectionId: string): FileAccountFacts {
  return useStorageAccountInfoStore((state) => {
    const entry = state.byConnection[connectionId];
    return entry?.status === 'ready' ? entry.info.files ?? UNKNOWN_FACTS : UNKNOWN_FACTS;
  });
}

export function quotaRangeText(facts: Pick<FileAccountFacts, 'billing' | 'largeFileShares'>): string {
  const range = shareQuotaRange(facts);
  return `From ${range.min.toLocaleString('en-US')} to ${range.max.toLocaleString('en-US')} GiB.${range.note ? ` ${range.note}` : ''}`;
}
